<template>
  <div class="banner-1">
    <img :src="innerbanner" alt="">
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    detail: {
      default: false
    }
  },
  data () {
    return {
      List: [],
      defaultinnerbanner: require('@/assets/common/images/innerbanner.jpg'),
      innerbanner: ''
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'pcinnerbanner') {
          if (item.imgPath !== undefined && item.imgPath !== '') {
            this.innerbanner = item.imgPath
            this.getadDetailbanner(item.adDetails)
          } else {
            this.innerbanner = this.defaultinnerbanner
            this.getadDetailbanner(item.adDetails)
          }
        }
      })
    },
    getadDetailbanner (list) {
      if (list.length > 0) {
        list.forEach(items => {
          if (parseInt(items.adName) === parseInt(this.$route.query.columnId)) {
            this.innerbanner = items.imgPath
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/banner/index.vue